import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UploadCloud, Linkedin, PencilLine, ArrowRight } from "lucide-react";
import CvUploader from "./CvUploader";
import LinkedInImport from "./LinkedInImport";

const TABS = [["file", "Upload my CV", UploadCloud], ["linkedin", "Create from LinkedIn", Linkedin], ["scratch", "Build from scratch", PencilLine]];

function Scratch({ testid }) {
  const navigate = useNavigate();
  return (
    <div className="rounded-2xl border border-line bg-canvas p-5" data-testid={testid}>
      <p className="font-semibold text-ink">No CV or LinkedIn? Start with your profile.</p>
      <p className="text-sm text-body mt-1">Add your jobs, education and skills in your own words, and we'll write a polished CV from them.</p>
      <button data-testid={`${testid}-open`} onClick={() => navigate("/dashboard/profile")} className="mt-4 gi-btn gi-btn-primary gi-btn-sm">
        Open my profile <ArrowRight className="w-4 h-4" aria-hidden="true" />
      </button>
    </div>
  );
}

export default function CvSourceTabs({ onDone, compact = false, testid = "cv-source", uploadLabel }) {
  const [tab, setTab] = useState("file");
  return (
    <div data-testid={testid}>
      <div role="tablist" aria-label="How to add your CV" className="inline-flex gap-1 p-1 rounded-xl bg-subtle mb-4 max-w-full overflow-x-auto scroll-row">
        {TABS.map(([id, l, Icon]) => (
          <button key={id} role="tab" aria-selected={tab === id} data-testid={`${testid}-tab-${id}`} onClick={() => setTab(id)}
            className={`flex items-center gap-2 px-3.5 py-2 min-h-[40px] rounded-lg text-sm font-semibold whitespace-nowrap transition-colors ${tab === id ? "bg-surface text-ink shadow-card" : "text-body hover:text-ink"}`}>
            <Icon className="w-4 h-4" aria-hidden="true" /> {l}
          </button>
        ))}
      </div>
      {tab === "file" && <CvUploader compact={compact} onUploaded={onDone} label={uploadLabel} testid={`${testid}-upload`} />}
      {tab === "linkedin" && <LinkedInImport compact={compact} onImported={onDone} testid={`${testid}-linkedin`} />}
      {tab === "scratch" && <Scratch testid={`${testid}-scratch`} />}
    </div>
  );
}
